<div class="app-container">
  @if (isMobile) {
  <mat-toolbar>
    <button mat-icon-button (click)="drawer.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar>
  }
  <mat-drawer-container autosize>
    <mat-drawer #drawer class="sidenav" [opened]="sidenavOpened" [mode]="mode">
      <div class="logo">Chronos</div>
      <mat-nav-list>
        @if (!authService.isUserLoggedIn()) {
        <a mat-list-item routerLink="/login" routerLinkActive="active">
          <mat-icon matListItemIcon>login</mat-icon>
          <span matListItemTitle>Login</span>
        </a>
        }

        @if (authService.isUserLoggedIn()) {
        <a mat-list-item routerLink="/tracker-page" routerLinkActive="active">
          <mat-icon matListItemIcon>timer</mat-icon>
          <span matListItemTitle>Timer</span>
        </a>

        <a mat-list-item routerLink="/tags" routerLinkActive="active">
          <mat-icon matListItemIcon>sell</mat-icon>
          <span matListItemTitle>Tags</span>
        </a>

        <a mat-list-item routerLink="/projects-page" routerLinkActive="active">
          <mat-icon matListItemIcon>folder</mat-icon>
          <span matListItemTitle>Projects</span>
        </a>

        <a mat-list-item routerLink="/clients-page" routerLinkActive="active">
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>Clients</span>
        </a>

        <a mat-list-item routerLink="/members-page" routerLinkActive="active">
          <mat-icon matListItemIcon>group</mat-icon>
          <span matListItemTitle>Members</span>
        </a>

        <a mat-list-item routerLink="/reports-page" routerLinkActive="active">
          <mat-icon matListItemIcon>assessment</mat-icon>
          <span matListItemTitle>Reports</span>
        </a>

        <a mat-list-item (click)="logOut()" (keydown.enter)="logOut()" tabindex="0" role="button">
          <mat-icon matListItemIcon>logout</mat-icon>
          <span matListItemTitle>Logout</span>
        </a>

        }
      </mat-nav-list>

      <!-- TODO: Add styling -->
      @if (userName) {
        <span class="user-name"><b>Current user:</b> {{userName}}</span>
      }
      <hr>
      @if (projectVersion) {
        <span class="user-name"><b>V</b>{{projectVersion}}</span>
      }
    </mat-drawer>

    <mat-drawer-content class="content">
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
